var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWavyCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22596 19.774C3.25288 18.801 3.89808 16.7596 3.40096 15.5644C2.90385 14.3692 1 13.3221 1 12C1 10.6779 2.88269 9.67308 3.40096 8.43558C3.91923 7.19808 3.25288 5.19904 4.22596 4.22596C5.19904 3.25288 7.24038 3.89808 8.43558 3.40096C9.63077 2.90385 10.6779 1 12 1C13.3221 1 14.3269 2.88269 15.5644 3.40096C16.8019 3.91923 18.801 3.25288 19.774 4.22596C20.7471 5.19904 20.1019 7.24038 20.599 8.43558C21.0962 9.63077 23 10.6779 23 12C23 13.3221 21.1173 14.3269 20.599 15.5644C20.0808 16.8019 20.7471 18.801 19.774 19.774C18.801 20.7471 16.7596 20.1019 15.5644 20.599C14.3692 21.0962 13.3221 23 12 23C10.6779 23 9.67308 21.1173 8.43558 20.599C7.19808 20.0808 5.19904 20.7471 4.22596 19.774Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6534 9.46143L10.4447 15.3845L7.3457 12.423",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyCircleCheck);
export default __webpack_public_path__ + "static/media/wavy-circle-check.496fe0f2a9e856f376dea22af99d106d.svg";
export { ForwardRef as ReactComponent };